import { createReducer } from '@reduxjs/toolkit'
import {
  acceptDisclaimerNote,
  addConversation,
  clearConversation,
  fetchThreadId,
  resetErrorMessage,
  sendChatRequest,
  sendMsgFeedback,
  getDisclaimerNote,
  cancelRequest,
} from './thunk'
import { t } from 'i18next'

const initialState = {
  conversation: [],
  error: null,
  id: null,
  loading: true,
  isLegalAccepted: true,
  isLegalLoading: true,
}

const reducers = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchThreadId.pending, (acc) => {
      acc.loading = true
      acc.error = null
    })
    .addCase(fetchThreadId.fulfilled, (acc, { payload }) => {
      acc.id = payload.id
      acc.conversation = [
        {
          id: '',
          msg: t('chatbot.welcome'),
          date: new Date().getTime(),
        },
      ]
      acc.loading = false
    })
    .addCase(fetchThreadId.rejected, (acc, { error }) => {
      acc.loading = false
      acc.error = error.message
    })
    .addCase(sendChatRequest.pending, (acc) => {
      acc.loading = true
      acc.error = null
    })
    .addCase(sendChatRequest.fulfilled, (acc, { payload }) => {
      acc.conversation.push({
        ...payload,
        date: new Date().getTime(),
      })
      acc.loading = false
      acc.error = null
    })
    .addCase(sendChatRequest.rejected, (acc, { error }) => {
      acc.conversation[acc.conversation.length - 1] = {
        ...acc.conversation[acc.conversation.length - 1],
        error: error as string,
      }
      acc.loading = false
    })
    .addCase(sendMsgFeedback.fulfilled, (acc, { meta }) => {
      const { messageId, status } = meta.arg
      const conversationIndex = acc.conversation.findIndex(
        (msg) => msg.id === messageId,
      )
      acc.conversation[conversationIndex] = {
        ...acc.conversation[conversationIndex],
        feedback: status,
      }
      acc.error = null
    })
    .addCase(addConversation, (acc, { payload }) => {
      acc.conversation.push({
        id: acc.conversation.length,
        msg: payload,
        date: new Date().getTime(),
        isFromUser: true,
      })
    })
    .addCase(resetErrorMessage, (acc) => {
      acc.conversation[acc.conversation.length - 1] = {
        ...acc.conversation[acc.conversation.length - 1],
        error: null,
      }
    })
    .addCase(clearConversation, (acc) => {
      acc.conversation = []
      acc.id = null
      acc.error = null
      acc.loading = true
      acc.isLegalAccepted = true
    })
    .addCase(cancelRequest, (acc) => {
      acc.loading = false
      acc.error = null
    })
    .addCase(acceptDisclaimerNote.fulfilled, (acc) => {
      acc.isLegalAccepted = true
    })
    .addCase(acceptDisclaimerNote.rejected, (acc, { error }) => {
      acc.error = error.message
    })
    .addCase(getDisclaimerNote.fulfilled, (acc) => {
      acc.isLegalLoading = false
      acc.isLegalAccepted = true
    })
    .addCase(getDisclaimerNote.rejected, (acc, { error }) => {
      if (error.message.includes('404')) {
        acc.isLegalAccepted = false
      } else {
        acc.error = error.message
      }
      acc.isLegalLoading = false
    })
    .addCase(getDisclaimerNote.pending, (acc) => {
      acc.isLegalLoading = true
    })
})

export default reducers
